import "./styles.scoped.css";
export default {
    "root": "awsui_root_14cnr_zbvdk_93",
    "trigger": "awsui_trigger_14cnr_zbvdk_106",
    "dropdown": "awsui_dropdown_14cnr_zbvdk_109",
    "nowrap": "awsui_nowrap_14cnr_zbvdk_120",
    "open": "awsui_open_14cnr_zbvdk_123"
};
